import { BIRDVIEW_SECTION_ITEMS_LIMIT } from '../../constants/dashboard'
import { PAGE_DEFAULT_VALUE } from '../../constants/route'
import { getPaginationApiParams } from '../../utils/pagination'
import { getUserFullName } from '../../utils/user'
import { isTaskDone, isTaskDoneCommitType } from '../Task'

import { BIRDVIEW_META_SEPARATOR } from './DashboardBirdview.constants'

function getBirdviewRequestAssigneeName(request) {
  const assignee = request.assignees?.[0]

  return assignee ? getUserFullName(assignee) : undefined
}

function checkCanToggleBirdviewActivity(activity) {
  return (
    isTaskDoneCommitType(activity) &&
    (isTaskDone(activity)
      ? activity.permissions?.can_mark_as_open
      : activity.permissions?.can_mark_as_done)
  )
}

export function getBirdviewFirstPageParams() {
  return getPaginationApiParams({
    page: PAGE_DEFAULT_VALUE,
    pageSize: BIRDVIEW_SECTION_ITEMS_LIMIT,
  })
}

export function getBirdviewWidgetPageParams({ scope }) {
  return { ...getBirdviewFirstPageParams(), scope }
}

// attention/ takes no page: every group comes back with its first `size` rows.
export function getBirdviewAttentionParams({ scope }) {
  return { scope, size: BIRDVIEW_SECTION_ITEMS_LIMIT }
}

export function toBirdviewListSection(data, toItem) {
  return { items: data.items.map(toItem), total: data.pagination.total }
}

export function toBirdviewWidgetRequestItem(request) {
  return {
    address: request.building?.title,
    assignee: getBirdviewRequestAssigneeName(request),
    canEditAssignee: request.permissions?.can_edit_assignee,
    deadline: request.due_date,
    flat: request.flat?.number,
    id: request.id,
    number: request.request_no,
    reason: request.reason,
    status: request.status_id,
    title: request.title,
    unread: request.unread,
  }
}

export function toBirdviewActivityItem(activity) {
  return {
    address: [activity.request?.building?.title, activity.request?.title]
      .filter(Boolean)
      .join(BIRDVIEW_META_SEPARATOR),
    canToggleDone: checkCanToggleBirdviewActivity(activity),
    deadline: activity.deadline,
    done: isTaskDone(activity),
    id: activity.id,
    requestId: activity.request?.id,
    title: activity.title,
  }
}
